/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import type { AxiosRequestConfig, AxiosResponse } from 'axios'
import { axiosInstance } from '../client'
import type {
	SubscriptionChangeTrialPlanPathParams,
	SubscriptionChangeTrialPlanRequest,
	SubscriptionChangeTrialPlanResponse,
} from '../types/SubscriptionChangeTrialPlan'

/**
 * PUT /:organisation/profiles/:profile/trial/plan
 * @see backend/nexus/modules/Billing/Http/Controllers/SubscriptionController.php SubscriptionController::changeTrialPlan
 */
export async function subscriptionChangeTrialPlan(
	organisation: SubscriptionChangeTrialPlanPathParams['organisation'],
	profile: SubscriptionChangeTrialPlanPathParams['profile'],
	data: SubscriptionChangeTrialPlanRequest,
	config?: AxiosRequestConfig,
): Promise<AxiosResponse<SubscriptionChangeTrialPlanResponse>> {
	return axiosInstance.put(`/${organisation}/profiles/${profile}/trial/plan`, data, config)
}
